import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/api';
import * as Moment from 'moment'

@Component({
  selector: 'app-choose-data-modal',
  templateUrl: './choose-data-modal.component.html',
  styleUrls: ['./choose-data-modal.component.css']
})
export class ChooseDataModalComponent implements OnInit {
  dataScelta: Date = null       //data scelta pcalendar
  it: any                       // Lingua del calendario
  dataString: string

  constructor(private ref: DynamicDialogRef) { }

  ngOnInit() {
    /**
     * Lingua italiana nel calendario
     */
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
      today: 'Oggi',
      clear: 'Cancella'
    };


  }

  /**
   * html button click
   */
  chooseBtnClick() {
    this.ref.close(this.dataScelta)
  }

  /**
   * format date for html
   * @param date string from service
   */
  formatDateForChart(date: any): string {
    // format date value
    let valueMoment = Moment(date, "YYYY-MM-DDTHH:mm:ssZ", true)
    if (valueMoment.isValid()) {
      date = valueMoment.format("DD/MM/YYYY")
    }
    return date
  }

  /**
   * onclick calendar event
   */
  setDataString() {
    if (this.dataScelta != null) {
      this.dataString = this.formatDateForChart(this.dataScelta)
    }
  }
}
